import { CreateMediaInputApiModel } from "@app/store/http/models/input";

export interface UpdateCompanyInputApiModel{
    logo: CreateMediaInputApiModel
}